import UtmParams from './utm-params';

export default UtmParams;
